import React, { useState, useEffect } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Space, Table, Typography, Tag, Segmented } from 'antd';
import axios from "axios";
import "./styles.css";
import {SERVER_BASE_URL} from "../../Constants";

const { Text } = Typography;

const Leaderboard = () => {
    const [competitions, setCompetitions] = useState([]);
    const [selectedCompetition, setSelectedCompetition] = useState(null);
    const [leaderboard, setLeaderboard] = useState([]);
    const [leaderboardUsers, setLeaderboardUsers] = useState([]);
    const [leaderboardWorkouts, setLeaderboardWorkouts] = useState([]);
    const [selectedGender, setSelectedGender] = useState("men");

    useEffect(() => {
        document.title = "Leaderboard";
    }, []);

    useEffect(() => {

        const fetchCompetitions = async () => {
            try {
                const response = await axios.get(SERVER_BASE_URL + 'api/competitions');
                console.log(response);
                // Handle successful response
                if (response.status === 200) {
                    setCompetitions(response.data);
                    setSelectedCompetition(response.data[0]);
                } else {
                    console.log(response);
                }

                const leaderboardResponse = await axios.get(SERVER_BASE_URL + 'api/leaderboard/' + response.data[0].competition_id);
                console.log("leaderboardResponse");
                console.log(leaderboardResponse);
                // Handle successful response
                if (leaderboardResponse.status === 200) {
                    console.log("leaderboardResponse data");
                    console.log(leaderboardResponse.data);
                    setLeaderboard(leaderboardResponse.data);

                    console.log("leaderboardResponse users");

                    console.log(leaderboardResponse.data.users);

                    setLeaderboardUsers(leaderboardResponse.data.users);
                    setLeaderboardWorkouts(leaderboardResponse.data.workouts);
                } else {
                    console.log(leaderboardResponse);
                }
            } catch (err) {
                // Handle API errors
                console.log(err);
            }
        };
        fetchCompetitions();

    }, []);

    useEffect(() => {
        const fetchResults = async () => {
            if (!selectedCompetition) return;

            console.log("Fetching results for competition:", selectedCompetition.competition_id);

            try {
                const leaderboardResponse = await axios.get(SERVER_BASE_URL + 'api/results/for-competition/' + selectedCompetition.competition_id);
                // Handle successful response
                if (leaderboardResponse.status === 200) {
                    console.log("leaderboardResponse hummus");
                    console.log(leaderboardResponse.data);
                    setLeaderboard(leaderboardResponse.data);
                } else {
                    console.log(leaderboardResponse);
                }
            } catch (err) {
                console.error("Error fetching results:", err);
            }
        };

        fetchResults();
    }, [selectedCompetition]); // This effect runs whenever selectedCompetition changes

    useEffect(() => {
        const updateLead = async () => {
            try {
                console.log("selectedCompetition");
                console.log(selectedCompetition);
                const leaderboardResponse = await axios.get(SERVER_BASE_URL + 'api/leaderboard/' + selectedCompetition.competition_id);
                console.log("leaderboardResponse");
                console.log(leaderboardResponse);
                // Handle successful response
                if (leaderboardResponse.status === 200) {
                    console.log("leaderboardResponse data");
                    console.log(leaderboardResponse.data);
                    setLeaderboard(leaderboardResponse.data);

                    console.log("leaderboardResponse users");

                    console.log(leaderboardResponse.data.users);

                    setLeaderboardUsers(leaderboardResponse.data.users);
                    setLeaderboardWorkouts(leaderboardResponse.data.workouts);
                } else {
                    console.log(leaderboardResponse);
                }
            } catch (err) {
                // Handle API errors
                console.log(err);
            }
        };
        updateLead()
    }, [selectedCompetition]);




    const handleCompetitionChange = (event) => {

        console.log(event.target.value)
        const competition = competitions.find(
            (comp) => comp.competition_id === parseInt(event.target.value)
        );
        console.log(" Competition changed --------------");
        console.log(competition);
        setSelectedCompetition(competition);
    };



    const columns = [
        {
            title: "Rank",
            dataIndex: "rank",
            key: "rank",
            width: 80,
            align: "center",
            sorter: (a, b) => a.rank - b.rank, // Sort by numerical rank
        },
        {
            title: "Athlete",
            dataIndex: "name",
            key: "name",
            width: 200,
            sorter: (a, b) => a.name.localeCompare(b.name), // Sort alphabetically
        },
        {
            title: "Points",
            dataIndex: "points",
            key: "points",
            width: 100,
            align: "center",
            sorter: (a, b) => a.points - b.points, // Sort numerically
        },
    ];

    leaderboardWorkouts?.forEach((workout) => {
        columns.push({
            title: workout.workout_name,
            dataIndex: workout.workout_id,
            key: workout.workout_id,
            width: 120,
            align: "center",
            sorter: (a, b) => {
                const scoreA = parseFloat(a[workout.workout_id]) || 0;
                const scoreB = parseFloat(b[workout.workout_id]) || 0;
                return scoreA - scoreB;
            },
        });
    });


    const rowData = leaderboardUsers.filter(athlete => athlete.user.competition_gender.toLowerCase() === selectedGender.toLowerCase()
    ).map((athlete, index) => {
        const row = {
            key: index,
            rank: athlete.overallRank,
            name: `${athlete.user.fist_name} ${athlete.user.last_name}`,
            points: athlete.competitionScore,
            details: athlete, // Store the full athlete object in the row for the expanded view
        };

        athlete.workoutResults.forEach((result) => {
            row[result.workout_id] = result.display_score;
        });

        return row;
    });

    const expandedRowRender = (record) => {
        return (
            <div className="expanded-row">
                <Text strong>Email:</Text> {record.details.user.email} <br />
            </div>
        );
    };


    return (
        <Container className="mt-4">
            <h2 className="mb-4">Competition Leaderboard</h2>
            <Form.Group controlId="competitionSelect" className="mb-3">
                <Form.Group as={Row} controlId="selectCompetition" className="mb-3">
                    <Form.Label sm="2" column="sm">Select a Competition:</Form.Label>
                    <Col sm="10">
                        <Form.Select onChange={handleCompetitionChange} value={selectedCompetition?.competition_id || ""}>
                            {competitions.map((comp) => (
                                <option key={comp.competition_id} value={comp.competition_id}>{comp.competition_name}</option>
                            ))}
                        </Form.Select>
                    </Col>
                </Form.Group>
            </Form.Group>
            {selectedCompetition && (
                <div>
                    <Segmented
                        options={["Men", "Women"]}
                        value={selectedGender === "men" ? "Men" : "Women"}
                        onChange={(value) => setSelectedGender(value.toLowerCase())}
                        block
                    />
                    <Table
                        columns={columns}
                        dataSource={rowData}
                        rowClassName={(record, index) => (index % 2 === 0 ? "even-row" : "odd-row")}
                        pagination={false}
                        scroll={{ x: "max-content" }}
                    // can add row expanding etc but doesnt nice to have all rows expanded ona lkeaderboard
                    // expandable={{
                    //     expandedRowRender,
                    //     expandRowByClick: true,
                    //     showExpandColumn: false,
                    // }}
                    />
                </div>

            )}
        </Container>
    );
};

export default Leaderboard;
